// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.exerciseContainer {
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    position: relative;
}

/* Eyes/Avatar area - flex to vertically center */
.exerciseEyesArea {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 0;
    padding: 16px 0;
}

/* Display Messages */
.displayCount {
    text-align: center;
    color: var(--text-primary);
    font-size: 36px;
    font-weight: 600;
    padding: 24px;
    margin: 20px auto;
    background: var(--bg-overlay-light);
    border-radius: 16px;
    border: 2px solid var(--border-secondary);
    min-width: 280px;
    backdrop-filter: blur(10px);
    transition: background-color 0.3s, border-color 0.3s, color 0.3s;
}

.displayNext {
    position: absolute;
    bottom: 120px;
    left: 50%;
    transform: translateX(-50%);
    color: var(--text-muted);
    font-size: 16px;
    padding: 8px 20px;
    background: var(--bg-overlay);
    border-radius: 20px;
    border: 1px solid var(--border-tertiary);
    white-space: nowrap;
    backdrop-filter: blur(10px);
    transition: background-color 0.2s, border-color 0.2s, color 0.2s, transform 0.2s;
    cursor: pointer;
    user-select: none;
}

.displayNext:hover {
    background: var(--bg-overlay-light);
    border-color: var(--border-secondary);
    color: var(--text-secondary);
    transform: translateX(-50%) scale(1.02);
}

.displayNext:active {
    transform: translateX(-50%) scale(0.98);
}

/* Status Display */
.statusHolder {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    max-width: 600px;
    padding: 20px 24px;
    background: var(--bg-overlay);
    border-radius: 16px;
    border: 2px solid var(--border-secondary);
    margin-bottom: 32px;
    backdrop-filter: blur(10px);
    transition: background-color 0.3s, border-color 0.3s;
}

.currentStep {
    color: var(--text-primary);
    font-size: 22px;
    font-weight: 600;
    display: inline-block;
}

.currentStep:first-child {
    color: var(--text-secondary);
    flex: 1;
}

.currentStep:last-child {
    color: var(--accent-primary);
    font-variant-numeric: tabular-nums;
}

/* Responsive Adjustments */
@media (max-width: 768px) {
    .exerciseContainer {
        padding: 16px;
        padding-top: max(100px, env(safe-area-inset-top));
        /* Clear fixed back button */
        padding-bottom: max(16px, env(safe-area-inset-bottom));
        min-height: 100vh;
        min-height: 100dvh;
    }


    .displayCount {
        font-size: 24px;
        min-width: 200px;
        padding: 16px;
        margin: 12px auto;
    }

    .displayNext {
        font-size: 13px;
        position: static;
        transform: none;
        text-align: center;
        width: calc(100% - 32px);
        margin: 8px auto 0;
        order: 10;
    }

    .displayNext:hover {
        transform: scale(1.02);
    }

    .displayNext:active {
        transform: scale(0.98);
    }

    .statusHolder {
        padding: 14px 16px;
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
        margin-bottom: 16px;
    }

    .currentStep {
        font-size: 16px;
    }
}

/* ===== Completion Celebration ===== */
.finish-celebration {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    padding: 32px 24px;
    animation: celebrationIn 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes celebrationIn {
    from { opacity: 0; transform: scale(0.8) translateY(20px); }
    to { opacity: 1; transform: scale(1) translateY(0); }
}

.finish-emoji {
    font-size: 72px;
    animation: bounce 1s ease infinite;
}

@keyframes bounce {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-12px); }
}

.finish-title {
    font-size: 28px;
    font-weight: 700;
    color: var(--text-primary);
}

.finish-stats {
    display: flex;
    gap: 24px;
    margin: 8px 0;
}

.finish-stat {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    padding: 16px 20px;
    background: var(--bg-overlay-light);
    border-radius: 16px;
    border: 1px solid var(--border-secondary);
    min-width: 100px;
}

.finish-stat-icon {
    font-size: 24px;
}

.finish-stat-value {
    font-size: 28px;
    font-weight: 700;
    color: var(--text-primary);
}

.finish-stat-label {
    font-size: 12px;
    color: var(--text-muted);
    text-align: center;
}

.finish-actions {
    display: flex;
    gap: 12px;
    margin-top: 12px;
}

.finish-btn {
    padding: 14px 28px;
    border-radius: 50px;
    font-size: 16px;
    font-weight: 600;
    text-decoration: none;
    transition: all 0.2s ease;
    text-align: center;
}

.finish-btn-primary {
    background: var(--accent-primary);
    color: white;
}

.finish-btn-primary:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(74, 144, 226, 0.4);
}

.finish-btn-secondary {
    background: var(--bg-secondary);
    color: var(--text-primary);
    border: 1px solid var(--border-secondary);
}

.finish-btn-secondary:hover {
    border-color: var(--border-hover);
    transform: translateY(-2px);
}

/* Extra small screens (320px - old iPhones, small Android) */
@media (max-width: 360px) {
    .displayCount {
        font-size: 20px;
        min-width: 160px;
        padding: 12px;
    }

    .currentStep {
        font-size: 14px;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/Exercise.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;AACtB;;AAEA,iDAAiD;AACjD;IACI,OAAO;IACP,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,aAAa;IACb,eAAe;AACnB;;AAEA,qBAAqB;AACrB;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,iBAAiB;IACjB,mCAAmC;IACnC,mBAAmB;IACnB,yCAAyC;IACzC,gBAAgB;IAChB,2BAA2B;IAC3B,gEAAgE;AACpE;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,2BAA2B;IAC3B,wBAAwB;IACxB,eAAe;IACf,iBAAiB;IACjB,6BAA6B;IAC7B,mBAAmB;IACnB,wCAAwC;IACxC,mBAAmB;IACnB,2BAA2B;IAC3B,gFAAgF;IAChF,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,mCAAmC;IACnC,qCAAqC;IACrC,4BAA4B;IAC5B,uCAAuC;AAC3C;;AAEA;IACI,uCAAuC;AAC3C;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,6BAA6B;IAC7B,mBAAmB;IACnB,yCAAyC;IACzC,mBAAmB;IACnB,2BAA2B;IAC3B,oDAAoD;AACxD;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,4BAA4B;IAC5B,OAAO;AACX;;AAEA;IACI,4BAA4B;IAC5B,kCAAkC;AACtC;;AAEA,2BAA2B;AAC3B;IACI;QACI,aAAa;QACb,iDAAiD;QACjD,4BAA4B;QAC5B,sDAAsD;QACtD,iBAAiB;QACjB,kBAAkB;IACtB;;;IAGA;QACI,eAAe;QACf,gBAAgB;QAChB,aAAa;QACb,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,eAAe;QACf,kBAAkB;QAClB,wBAAwB;QACxB,kBAAkB;QAClB,SAAS;IACb;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,kBAAkB;QAClB,sBAAsB;QACtB,uBAAuB;QACvB,QAAQ;QACR,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA,uCAAuC;AACvC;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,+DAA+D;AACnE;;AAEA;IACI,OAAO,UAAU,EAAE,sCAAsC,EAAE;IAC3D,KAAK,UAAU,EAAE,iCAAiC,EAAE;AACxD;;AAEA;IACI,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,WAAW,wBAAwB,EAAE;IACrC,MAAM,4BAA4B,EAAE;AACxC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,mCAAmC;IACnC,mBAAmB;IACnB,yCAAyC;IACzC,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,iCAAiC;IACjC,YAAY;AAChB;;AAEA;IACI,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,+BAA+B;IAC/B,0BAA0B;IAC1B,yCAAyC;AAC7C;;AAEA;IACI,iCAAiC;IACjC,2BAA2B;AAC/B;;AAEA,6DAA6D;AAC7D;IACI;QACI,eAAe;QACf,gBAAgB;QAChB,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".exerciseContainer {\n    width: 100%;\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 20px;\n    position: relative;\n}\n\n/* Eyes/Avatar area - flex to vertically center */\n.exerciseEyesArea {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    min-height: 0;\n    padding: 16px 0;\n}\n\n/* Display Messages */\n.displayCount {\n    text-align: center;\n    color: var(--text-primary);\n    font-size: 36px;\n    font-weight: 600;\n    padding: 24px;\n    margin: 20px auto;\n    background: var(--bg-overlay-light);\n    border-radius: 16px;\n    border: 2px solid var(--border-secondary);\n    min-width: 280px;\n    backdrop-filter: blur(10px);\n    transition: background-color 0.3s, border-color 0.3s, color 0.3s;\n}\n\n.displayNext {\n    position: absolute;\n    bottom: 120px;\n    left: 50%;\n    transform: translateX(-50%);\n    color: var(--text-muted);\n    font-size: 16px;\n    padding: 8px 20px;\n    background: var(--bg-overlay);\n    border-radius: 20px;\n    border: 1px solid var(--border-tertiary);\n    white-space: nowrap;\n    backdrop-filter: blur(10px);\n    transition: background-color 0.2s, border-color 0.2s, color 0.2s, transform 0.2s;\n    cursor: pointer;\n    user-select: none;\n}\n\n.displayNext:hover {\n    background: var(--bg-overlay-light);\n    border-color: var(--border-secondary);\n    color: var(--text-secondary);\n    transform: translateX(-50%) scale(1.02);\n}\n\n.displayNext:active {\n    transform: translateX(-50%) scale(0.98);\n}\n\n/* Status Display */\n.statusHolder {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    max-width: 600px;\n    padding: 20px 24px;\n    background: var(--bg-overlay);\n    border-radius: 16px;\n    border: 2px solid var(--border-secondary);\n    margin-bottom: 32px;\n    backdrop-filter: blur(10px);\n    transition: background-color 0.3s, border-color 0.3s;\n}\n\n.currentStep {\n    color: var(--text-primary);\n    font-size: 22px;\n    font-weight: 600;\n    display: inline-block;\n}\n\n.currentStep:first-child {\n    color: var(--text-secondary);\n    flex: 1;\n}\n\n.currentStep:last-child {\n    color: var(--accent-primary);\n    font-variant-numeric: tabular-nums;\n}\n\n/* Responsive Adjustments */\n@media (max-width: 768px) {\n    .exerciseContainer {\n        padding: 16px;\n        padding-top: max(100px, env(safe-area-inset-top));\n        /* Clear fixed back button */\n        padding-bottom: max(16px, env(safe-area-inset-bottom));\n        min-height: 100vh;\n        min-height: 100dvh;\n    }\n\n\n    .displayCount {\n        font-size: 24px;\n        min-width: 200px;\n        padding: 16px;\n        margin: 12px auto;\n    }\n\n    .displayNext {\n        font-size: 13px;\n        position: static;\n        transform: none;\n        text-align: center;\n        width: calc(100% - 32px);\n        margin: 8px auto 0;\n        order: 10;\n    }\n\n    .displayNext:hover {\n        transform: scale(1.02);\n    }\n\n    .displayNext:active {\n        transform: scale(0.98);\n    }\n\n    .statusHolder {\n        padding: 14px 16px;\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 8px;\n        margin-bottom: 16px;\n    }\n\n    .currentStep {\n        font-size: 16px;\n    }\n}\n\n/* ===== Completion Celebration ===== */\n.finish-celebration {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 20px;\n    padding: 32px 24px;\n    animation: celebrationIn 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n@keyframes celebrationIn {\n    from { opacity: 0; transform: scale(0.8) translateY(20px); }\n    to { opacity: 1; transform: scale(1) translateY(0); }\n}\n\n.finish-emoji {\n    font-size: 72px;\n    animation: bounce 1s ease infinite;\n}\n\n@keyframes bounce {\n    0%, 100% { transform: translateY(0); }\n    50% { transform: translateY(-12px); }\n}\n\n.finish-title {\n    font-size: 28px;\n    font-weight: 700;\n    color: var(--text-primary);\n}\n\n.finish-stats {\n    display: flex;\n    gap: 24px;\n    margin: 8px 0;\n}\n\n.finish-stat {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 4px;\n    padding: 16px 20px;\n    background: var(--bg-overlay-light);\n    border-radius: 16px;\n    border: 1px solid var(--border-secondary);\n    min-width: 100px;\n}\n\n.finish-stat-icon {\n    font-size: 24px;\n}\n\n.finish-stat-value {\n    font-size: 28px;\n    font-weight: 700;\n    color: var(--text-primary);\n}\n\n.finish-stat-label {\n    font-size: 12px;\n    color: var(--text-muted);\n    text-align: center;\n}\n\n.finish-actions {\n    display: flex;\n    gap: 12px;\n    margin-top: 12px;\n}\n\n.finish-btn {\n    padding: 14px 28px;\n    border-radius: 50px;\n    font-size: 16px;\n    font-weight: 600;\n    text-decoration: none;\n    transition: all 0.2s ease;\n    text-align: center;\n}\n\n.finish-btn-primary {\n    background: var(--accent-primary);\n    color: white;\n}\n\n.finish-btn-primary:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 16px rgba(74, 144, 226, 0.4);\n}\n\n.finish-btn-secondary {\n    background: var(--bg-secondary);\n    color: var(--text-primary);\n    border: 1px solid var(--border-secondary);\n}\n\n.finish-btn-secondary:hover {\n    border-color: var(--border-hover);\n    transform: translateY(-2px);\n}\n\n/* Extra small screens (320px - old iPhones, small Android) */\n@media (max-width: 360px) {\n    .displayCount {\n        font-size: 20px;\n        min-width: 160px;\n        padding: 12px;\n    }\n\n    .currentStep {\n        font-size: 14px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
